export function isSafeHttpUrl(url: string): boolean {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

export function safeOpenInNewTab(url?: string | null): void {
  if (!url || !isSafeHttpUrl(url)) return;
  window.open(url, '_blank', 'noopener,noreferrer');
}
